import React from 'react';
import { BadgeCheckIcon, ShieldAlertIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { SectionCTA } from '../SectionCTA';
import { audience } from '../../data/content';
export function Audience() {
  return <section className="w-full bg-mist px-4 py-14 sm:py-20" aria-labelledby="aud-title" data-id="element-67" data-mp="1dyi8mtj5mtng">
      <div className="mx-auto max-w-3xl" data-id="element-68" data-mp="1hyipektq7gxo">
        <SectionHeading id="aud-title" lead="This blueprint is intended for:" data-id="element-69" data-mp="25o3b3bh9ksan">
          Designed for professionals who work with <span className="text-accent-600" data-id="element-70" data-mp="2an6gwy52j2jo">aesthetic laser procedures</span>
        </SectionHeading>

        <ul className="mt-8 divide-y divide-navy-900/10 rounded-3xl bg-white px-5 ring-1 ring-navy-900/10" data-id="element-71" data-mp="1wnygk1x65odw">
          {audience.map(a => <li key={a} className="flex items-start gap-3 py-4 text-base font-medium text-navy-900 sm:text-lg" data-id="element-72" data-mp="21ocm9dbasm8r">
              <BadgeCheckIcon className="mt-0.5 h-6 w-6 shrink-0 text-accent-500" aria-hidden="true" data-id="element-73" data-mp="lacni5o6v2n3" />
              {a}
            </li>)}
        </ul>

        <div className="mt-6 flex items-start gap-3 rounded-2xl bg-gold-400/15 p-5 ring-1 ring-gold-500/50" data-id="element-74" data-mp="zmtiugu9j9q2">
          <ShieldAlertIcon className="mt-0.5 h-6 w-6 shrink-0 text-gold-700" aria-hidden="true" data-id="element-75" data-mp="up1gstzwm785" />
          <div data-id="element-76" data-mp="19lsij9x1vv0x">
            <p className="font-display font-black uppercase text-navy-900" data-id="element-77" data-mp="19iehc504hrv2">Professional use only</p>
            <p className="mt-1 text-sm leading-relaxed text-ink/80" data-id="element-78" data-mp="14nqzuq3jdxpz">
              This resource is not intended for unlicensed practitioners, independent self-treatment, or patients
              seeking to diagnose their own complications. It does not provide authorization to perform procedures
              outside professional scope.
            </p>
          </div>
        </div>

        <SectionCTA label="Yes, this is for my practice" data-id="element-79" data-mp="1ncnskpjaci63" />
      </div>
    </section>;
}